app.exerciseFilter = {
	settings: {
		$el: $('#data-exercise-filter')
	},

	init: function () {
		var localTag = localStorage.getItem('exercise-filter-tag');

		app.exerciseFilter.settings.$el.on('click', '.tab', function () {
			var $tab = $(this),
				data = $tab.data(),
				tag = data.exerciseFilter;

			app.exerciseFilter.set(tag);
		});

		if (localTag !== null) {
			app.exerciseFilter.changeTab(localTag);
		}
	},

	set: function (tag) {
		var $cardFiltercontainer = $('.cards-filter-container');

		$('#exercise-filter-style').remove();

		if (tag !== 'all') {
			app.exerciseFilter.settings.$el.after('<style id="exercise-filter-style">[data-exercise-tags] {display: none} [data-exercise-tags*=' + tag + '] { display: block; }</style>');

			$cardFiltercontainer.each(function () {
				var $container = $(this);

				if ($container.find('[data-exercise-tags*=' + tag + ']').length === 0) {
					$container.hide();
				} else {
					$container.show();
				}
			});
		} else {
			$cardFiltercontainer.show();
		}

		localStorage.setItem('exercise-filter-tag', tag);
	},

	changeTab: function (tag) {
		$('[data-exercise-filter="' + tag + '"]').trigger('click');
	}
};